<template>
<div class="ementalist">
  <EmentaCalendar 
    @updated-week="getEmentaForChoosenWeek"
    @selected-day="dayWasSelected" />
  <RefeicaoSeletor 
    :currentRefeicao="currentRefeicao"
    @set-refeicao="setRefeicao"/> 
  <div class="row ementadisplay" v-if="currentDay != null">
    <div class="small-12 medium-12 large-12 columns">
      <transition-group class="row" tag="div" name="slide-fade">
        <RestauranteEmenta 
          :key="ementa.Restaurante"
          v-for="ementa in getEmentaForDay()"
          :ementa="ementa"
          :refeicao="currentRefeicao"
          :refeicoes="refeicoes" />
      </transition-group>
      <transition name="msg-fade">
        <div class="small-12 medium-12 large-12 columns">
          <p class="noementa" v-if="getEmentaForDay().length == 0">
            <img src="https://www.uma.pt/wp-content/themes/uma/images/error_icon-29.png"
              class="icon_erro"> {{ $t("UMA_LANG_SASUMA_REFEICAO_SEM_EMENTAS") }}
          </p>
        </div>
      </transition>
    </div>
  </div>
</div>
</template>

<script>
import { ref } from "vue";
import { i18n } from '@/main.js';
import axios from "@/axios";
import EmentaCalendar from "@/components/Ementa/EmentaCalendar.vue";
import RefeicaoSeletor from "@/components/Ementa/RefeicaoSelector.vue";
import RestauranteEmenta from "@/components/Ementa/RestaurantEmenta.vue";

export default {
  components:{
    EmentaCalendar,
    RefeicaoSeletor,
    RestauranteEmenta
  },
  setup () {

    const currentDay = ref(new Date().getDay());
    const weekBefore = ref(0)
    
    const currentRefeicao = ref("almoco")
    const setRefeicao = (refeicao) => {
      currentRefeicao.value = refeicao;
    }

    const ementas = ref({ 1:[],2:[], 3:[],4:[],5:[],6:[] });

    const lang = i18n.global.locale;
    
    const getEmentaForWeek = (selectedWeekStart,selectedWeekEnd) => {
      // Format dates as 'YYYYMMDD'
      let formatYYYYMMDD = (date) => {
          let year = date.getFullYear();
          let month = date.getMonth() + 1; // JavaScript months are 0-based.
          let day = date.getDate();
          return `${year}${month.toString().padStart(2, '0')}${day.toString().padStart(2, '0')}`;
      };

      let url = `/ementas?idioma=${lang}&startdate=${formatYYYYMMDD(selectedWeekStart)}&enddate=${formatYYYYMMDD(selectedWeekEnd)}`;

      axios.get(url).then(data => {
        ementas.value = { 1:[],2:[], 3:[],4:[],5:[],6:[] };
        data.data.map(el => {
          const dia = new Date(el.ementa_dia).getUTCDay();
          ementas.value[dia].push(el)
        });
      }).catch(error => {
          console.log(error);
      });
    }
    
    const getEmentaForChoosenWeek = (data) => {
      getEmentaForWeek(data.start,data.end)
    }

    const getEmentaForToday = () => {
      let now = new Date();
      now.setDate(now.getDate() - now.getDay() - 6 * Math.abs(weekBefore.value)); // Move to Monday of the week `weekBefore` weeks ago
      let selectedWeekStart = new Date(now);
      let selectedWeekEnd = new Date(now);
      selectedWeekEnd.setDate(selectedWeekStart.getDate() + 6); // Set to Sunday of the same week
      getEmentaForWeek(selectedWeekStart,selectedWeekEnd)
    }

    getEmentaForToday();

    const getEmentaForDay = () => {
      return ementas.value[currentDay.value].filter(el => el.refeicao == currentRefeicao.value);
    }

    const { t } = i18n.global;

    const refeicoes = ref([
      {label: t('refeicoes.Sopa'),value:"Sopa"},
      {label: t('refeicoes.Carne'),value:"Prato"},
      {label: t('refeicoes.Peixe'),value:"Prato de Peixe"},
      {label: t('refeicoes.Vegetariano'),value:"Vegetariano"},
      {label: t('refeicoes.Acompanhamento'),value:"Acompanhamento"},
      {label: t('refeicoes.sandes'),value:"sandesdodia"},
      {label: t('refeicoes.salada'),value:"salada"},
      {label: t('refeicoes.Sobremesa'),value:"Sobremesa"},
    ]);

    const dayWasSelected = day => {
      currentDay.value = day.getDay();
    }

    return {
      getEmentaForChoosenWeek,
      dayWasSelected,
      refeicoes,
      getEmentaForDay,
      setRefeicao,
      currentDay,
      currentRefeicao
    }
  }
}
</script>

<style lang="scss" scoped>
.ementadisplay > .columns{
  padding-right: 0;
  padding-left: 0;
}

.noementa{
  margin-top: 15px;
  margin-bottom: 55px;
  font-size: 16px;
  font-family: "Montserrat Semibold";
  color: #707475;
  text-align: center;
  margin-left: -20px;
}

.icon_erro {
  width: 38px;
  margin-right: 10px;
  margin-bottom: 5px;
}

.msg-fade-enter-active {
    transition: all .1s ease;
    transition-delay: .1s;

}
.msg-fade-leave-active {
    transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.msg-fade-enter, .msg-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
    /* transform: translateX(10px);*/
    opacity: 0;
}
</style>